/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import stylesModule from './CandidateLayout.module.less';
import styles1Module from './../recruiter/RecruiterLayout.module.less';
import CommonStylesModule from '../../styles/Common.module.less';
import Logo from '../../public/HotjobsLogo.svg';
import Image from 'next/image';
import Form from '../../components/form/Form';
import {
  Avatar,
  Button,
  Divider,
  Drawer,
  Dropdown,
  Grid,
  Menu,
  MenuProps,
  Select,
  Space,
} from 'antd';
import {
  DownOutlined,
  MenuOutlined,
  PhoneOutlined,
  PlusOutlined,
  UserOutlined,
} from '@ant-design/icons';
import Utils from '../../utils/Utils';
import Router, { useRouter } from 'next/router';
import { useConnection, useUserInfo } from '../../connection/Application';
import ChangePasswordModal, {
  ChangePasswordModalInstance,
} from '../../page-components/UserManagement/ChangePasswordModal';
import { ContentBlock, TextBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import { FlexBox } from '../../components/FlexBox';
import { useRecruiter } from '../../page-components/Recruiiter/RecruiterContext';
import { NotificationButton } from '../../components/NotificationButton/NotificationButton';
import Link from 'next/link';
import { SearchAutocomplete } from '../../page-components/search/components/SearchInputBar';
import QuickProfileBuildModal, {
  QuickProfileBuildInstance,
} from '../../components/OneStep/QuickProfileBuildModal';
import { useCookies } from 'react-cookie';
import { useCachedData } from '../../connection/CacheContext';
import { useSearchContext } from '../../page-components/search/SearchContext';
import LogoLite from '../../public/recruiter/become-recruiter.svg';
import { useForm } from 'antd/lib/form/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons/faPhoneVolume';
import SearchIcon from '../../public/icons/search.svg';
import Marquee from 'react-fast-marquee';
const styles: any = stylesModule;
const styles1: any = styles1Module;
const CommonStyles: any = CommonStylesModule;

type Props = {
  showSearch?: boolean;
  showBanner?: boolean;
  bordered: boolean;
  hideRecruiterButton?: boolean;
  showLogin: boolean;
  onShowLogin: () => void;
};

type MenuItem = Required<MenuProps>['items'][number];

export const UserMenu: FC<{
  onClick: () => void;
  hideRecruiterButton?: boolean;
  onClickQuick?: () => void;
  onClickForeignJobs?: () => void;
}> = (props) => {
  const connection = useConnection();
  const history = useRouter();
  const user = useUserInfo();
  const role = user?.role;
  const pwModal = useRef<ChangePasswordModalInstance>(null);
  const recruiters = useRecruiter()?.recruiters;
  const bp = Grid.useBreakpoint();

  const recruiterText = useMemo(
    () => (role && role.indexOf('recruiter') !== -1 ? 'Recruiter dashboard' : 'Become a recruiter'),
    [role],
  );

  return (
    <>
      <Menu
        className={styles.userMenu}
        id={'navbar_user_menu'}
        selectedKeys={[]}
        style={{ minWidth: '250px', overflow: 'none' }}>
        {/*{!recruiters && (*/}
        {/*  <Menu.Item*/}
        {/*    className={styles.profileItem1}*/}
        {/*    id={'navbar-user-profile-icon'}*/}
        {/*    onClick={() => {*/}
        {/*      history.push(`/profile/${user?.userId}`);*/}
        {/*      props.onClick();*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    My profile*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{recruiters && (*/}
        {/*  <Menu.Item*/}
        {/*    id={'navbar-user-profile-icon'}*/}
        {/*    onClick={() => {*/}
        {/*      history.push(`/profile/${user?.userId}`);*/}
        {/*      props.onClick();*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    <>*/}
        {/*      <ContentBlock*/}
        {/*        style={{ marginTop: 4 }}*/}
        {/*        align={'center'}*/}
        {/*        left={*/}
        {/*          <Avatar icon={user?.picture ? undefined : <UserOutlined />} src={user?.picture} />*/}
        {/*        }>*/}
        {/*        <ContentBlock*/}
        {/*          style={{ maxWidth: 300, whiteSpace: 'nowrap' }}*/}
        {/*          ellipsis={true}*/}
        {/*          align="left">*/}
        {/*          {`${user?.firstName} ${user?.lastName?.charAt(0) || ''}`}*/}
        {/*        </ContentBlock>*/}
        {/*      </ContentBlock>*/}
        {/*    </>*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{!recruiters && user?.userId && (*/}
        {/*  <Menu.Item*/}
        {/*    className={styles.profileItem1}*/}
        {/*    id={'navbar-user-profile-icon'}*/}
        {/*    onClick={() => {*/}
        {/*      history.push('/dashboard');*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    My dashboard*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{!recruiters && user?.userId && (*/}
        {/*  <Menu.Item*/}
        {/*    className={styles.profileItem1}*/}
        {/*    id={'navbar-user-profile-icon'}*/}
        {/*    onClick={() => {*/}
        {/*      history.push(`/referrals/${user?.userId}`);*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    My Referrals*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{!recruiters && (*/}
        {/*  <Menu.Item*/}
        {/*    className={styles.profileItem1}*/}
        {/*    id={'navbar-user-profile-icon'}*/}
        {/*    onClick={() => {*/}
        {/*      if (recruiterText === 'Recruiter dashboard') {*/}
        {/*        history.push('/recruiter');*/}
        {/*      } else {*/}
        {/*        history.push('/guest-recruiter');*/}
        {/*      }*/}
        {/*    }}*/}
        {/*    style={{*/}
        {/*      minWidth: '100%',*/}
        {/*      color: recruiterText === 'Become a recruiter' ? '#009E52' : undefined,*/}
        {/*    }}>*/}
        {/*    <div*/}
        {/*      style={{ color: recruiterText === 'Become a recruiter' ? '#009E52' : undefined }}*/}
        {/*      className={'flex item-center gap-[7px]'}>*/}
        {/*      {recruiterText}*/}
        {/*      {recruiterText === 'Become a recruiter' && (*/}
        {/*        <Image*/}
        {/*          style={{ marginTop: 1 }}*/}
        {/*          src={LogoLite}*/}
        {/*          width={19}*/}
        {/*          height={19}*/}
        {/*          alt={'Careers360 Logo'}*/}
        {/*          id={'recruiter-c360-logo'}*/}
        {/*        />*/}
        {/*      )}*/}
        {/*    </div>*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*<Divider />*/}
        {/*{recruiters && (*/}
        {/*  <div style={{ maxHeight: '42vh', overflow: 'scroll' }}>*/}
        {/*    <Menu className={styles.recruiterList}>*/}
        {/*      {recruiters.map((item) => (*/}
        {/*        <>*/}
        {/*          <Menu.Item*/}
        {/*            className={styles.recruiterListItem}*/}
        {/*            key={item.name}*/}
        {/*            onClick={() => {*/}
        {/*              props.onClick();*/}
        {/*              let part = window.location.pathname.split('/').slice(3).join('/');*/}
        {/*              if (part === 'jobs') {*/}
        {/*                part = 'jobs/All';*/}
        {/*              }*/}
        {/*              history.replace(`/recruiter/${item.recruiterId}/${part}`).then();*/}
        {/*            }}*/}
        {/*            style={{ minHeight: '48px', minWidth: '300px' }}>*/}
        {/*            <ContentBlock*/}
        {/*              style={{ marginTop: 4 }}*/}
        {/*              align={'center'}*/}
        {/*              left={*/}
        {/*                <Avatar*/}
        {/*                  size={40}*/}
        {/*                  icon={item?.logo ? undefined : <UserOutlined style={{ fontSize: 20 }} />}*/}
        {/*                  src={item?.logo}*/}
        {/*                />*/}
        {/*              }>*/}
        {/*              <ContentBlock*/}
        {/*                style={{ maxWidth: 300, whiteSpace: 'nowrap' }}*/}
        {/*                className={styles.recruiterNameItem}*/}
        {/*                ellipsis={true}*/}
        {/*                align="left">*/}
        {/*                {item.name}*/}
        {/*              </ContentBlock>*/}
        {/*            </ContentBlock>*/}
        {/*          </Menu.Item>*/}
        {/*          <hr style={{ marginTop: 0, maxWidth: 300, marginBottom: 0 }} />*/}
        {/*        </>*/}
        {/*      ))}*/}
        {/*    </Menu>*/}
        {/*    <div style={{ paddingTop: '15px' }} />*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*{recruiters && user?.userId && (*/}
        {/*  <Menu.Item*/}
        {/*    onClick={() => {*/}
        {/*      history.push('/dashboard');*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    My dashboard*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{recruiters && user?.userId && (*/}
        {/*  <Menu.Item*/}
        {/*    onClick={() => {*/}
        {/*      history.push(`/referrals/${user?.userId}`);*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    My Referrals*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{recruiters && role && role.indexOf('recruiter') !== -1 && (*/}
        {/*  <Menu.Item*/}
        {/*    onClick={() => {*/}
        {/*      history.push('/recruiter');*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    Recruiter dashboard*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        {/*{recruiters && user && !user.social && (*/}
        {/*  <Menu.Item*/}
        {/*    onClick={() => {*/}
        {/*      props.onClick();*/}
        {/*      pwModal.current?.open();*/}
        {/*    }}*/}
        {/*    style={{ minWidth: '100%' }}>*/}
        {/*    Change password*/}
        {/*  </Menu.Item>*/}
        {/*)}*/}
        <Menu.Item
          onClick={() => {
            connection.setToken(undefined);
            history.replace('/');
            props.onClick();
          }}
          style={{ minWidth: '100%' }}>
          Sign out
        </Menu.Item>
      </Menu>
      <ChangePasswordModal ref={pwModal} />
    </>
  );
};

export const NavbarUserInfo: FC<{
  theme?: string;
  hideRecruiterButton?: boolean;
  onClickQuick?: () => void;
  onClickForeignJobs?: () => void;
}> = (props) => {
  const user = useUserInfo();
  const recruiter = useRecruiter()?.recruiter;
  const bp = Grid.useBreakpoint();
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
  return (
    <div className={styles.navbarUserInfo}>
      <ContentBlock
        align={'center'}
        left={bp.md && <NotificationButton darkMode={props.theme === 'dark'} />}
        right={
          <Dropdown
            trigger={['click']}
            open={dropdownVisible}
            placement={'bottomRight'}
            onOpenChange={setDropdownVisible}
            overlayClassName={styles.userPopover}
            overlay={
              <UserMenu
                onClick={() => setDropdownVisible(false)}
                onClickQuick={() => {
                  setDropdownVisible(false);
                  props.onClickQuick?.();
                }}
                onClickForeignJobs={() => {
                  setDropdownVisible(false);
                  props.onClickForeignJobs?.();
                }}
              />
            }>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: props.theme === 'dark' ? 'white' : 'black',
              }}>
              {/*<CaretDownOutlined id={'recruiter-dropdown-menu'} />*/}
              <i
                className="hidden lg:flex icon-chevron-down-1 text-[26px]"
                style={{ color: props.theme === 'dark' ? '#FFFFFF' : '#697281' }}
              />
            </div>
          </Dropdown>
        }>
        <Space
          style={{ textDecoration: 'none' }}
          id={'nav-link-user-name'}
          onClick={() => setDropdownVisible(true)}>
          <ContentBlock
            align={'center'}
            left={
              <Avatar
                size={41}
                icon={user?.picture ? undefined : <UserOutlined />}
                src={user?.picture}
              />
            }>
            <FlexBox direction={'vertical'} verticalAlign={'center'} style={{ overflow: 'hidden' }}>
              {/*{!bp.xs && (*/}
              {/*  <TextBlock*/}
              {/*    className={Utils.mergeClasses({*/}
              {/*      [styles.userInfo]: true,*/}
              {/*      [styles.userNameX]: props.theme !== 'dark',*/}
              {/*    })}*/}
              {/*    style={{ color: props.theme === 'dark' ? 'white' : 'black' }}>*/}
              {/*    {`${user?.firstName} ${user?.lastName?.charAt(0) || ''}`}*/}
              {/*  </TextBlock>*/}
              {/*)}*/}
              <TextBlock
                className={styles1.itemSubName}
                style={{
                  color: props.theme === 'dark' ? 'white' : 'black',
                }}>
                {recruiter?.name}
              </TextBlock>
            </FlexBox>
            {/*<FlexBox direction={'vertical'} verticalAlign={'center'} style={{ overflow: 'hidden' }}>*/}
            {/*  <TextBlock*/}
            {/*    className={styles.userInfo}*/}
            {/*    style={{ color: props.theme === 'dark' ? 'white' : 'black' }}>*/}
            {/*    {`${user?.firstName} ${user?.lastName.charAt(0)}`}*/}
            {/*  </TextBlock>*/}
            {/*  <TextBlock*/}
            {/*    className={styles1.itemSubName}*/}
            {/*    style={{*/}
            {/*      color: props.theme === 'dark' ? 'white' : 'black',*/}
            {/*    }}>*/}
            {/*    {recruiter?.name}*/}
            {/*  </TextBlock>*/}
            {/*</FlexBox>*/}
          </ContentBlock>
        </Space>
      </ContentBlock>
    </div>
  );
};

export const CandidateNavBar: FC<PropsWithChildren<Props>> = (props) => {
  const navbarClasses = [styles.navbar];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setCookies] = useCookies(['banner-closed']);
  const [showBanner, setShowBanner] = useState<boolean>(props.showBanner ?? false);
  const [searchType, setSearchType] = useState<string>('jobs');

  useEffect(() => {
    setShowBanner(props.showBanner ?? false);
  }, [props.showBanner]);
  const history = useRouter();
  const router = useRouter();
  const user = useUserInfo();
  const role = user?.role;
  const bp = Grid.useBreakpoint();
  const quick = useRef<QuickProfileBuildInstance>(null);
  const [servicesOpen, setServicesOpen] = useState<boolean>(false);
  const { masterdata, mainType } = useCachedData();
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<string | undefined>('');
  const [selectedKey, setSelectedKey] = useState<string[]>(['home']);
  const context = useSearchContext();
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Extract advertisement data once to optimize
  const navbarAdvert = context.advertisements?.find((v) => v.value === 'navbar-584*55');
  const navbarTopAdvert = context.advertisements?.find((v) => v.value === 'navbar-top');

  const foreignJobs = useMemo(() => {
    const typeId = mainType['Country'];
    const countries = masterdata[typeId] ?? [];

    const countriesX = countries
      .filter((v) => v.value !== 'Sri Lanka')
      .map((t) => `&country=${t.id}`)
      .join('');

    return `/?${countriesX}`;
  }, [mainType, masterdata]);

  const foriegnJobX = useMemo(() => {
    const typeId = mainType['Country'];
    const countries = masterdata[typeId] ?? [];

    return countries.filter((v) => v.value !== 'Sri Lanka').map((t) => `${t.id}`);
  }, [mainType, masterdata]);

  if (props.bordered) {
    navbarClasses.push(styles.navbarScrolled);
  }
  // const postJobText = useMemo(
  //   () => (role && role.indexOf('recruiter') !== -1 ? 'Recruiter Dashboard' : 'Post A Jobs'),
  //   [role],
  // );

  const postJobText = 'Post A Job';

  const query = router?.query;

  useEffect(() => {
    if (query.quick === 'true') {
      delete query?.quick;
      Router.push({
        query: {
          ...query,
        },
      });
      quick.current?.show();
    }
  }, [query.quick]);

  const onSearch = useCallback(
    (search?: string) => {
      const query: any = {};
      setValue(search ?? '');
      console.log('set search', search);
      context.search({ search: search });
      // if (search && search.trim() !== '') {
      //   query.search = search;
      // } else {
      //   query.search = '';
      // }
      // history.push({
      //   pathname: '',
      //   query: { ...query },
      // });
    },
    [context],
  );

  const menuItems: MenuItem[] = useMemo(() => {
    return [
      {
        label: 'Home',
        key: 'home',
        href: '/',
      },
      {
        label: 'Foreign jobs',
        key: 'foreign',
        href: foreignJobs,
      },
      {
        label: (
          <div className="flex items-center mt-3.5 !text-[#5E6670]">
            <span className="mr-2">Services</span>
            <DownOutlined className="!text-xs" size={8} />
          </div>
        ),
        key: 'services',
        children: [
          {
            label: <div className=" flex items-center -mt-1 text-sm text-[#5E6670]">Upload CV</div>,
            key: 'cv',
            href: '/profile',
          },
        ],
      },
    ];
  }, []);

  const onClickItem: MenuProps['onClick'] = (e) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const topLevelItem = menuItems.find((x) => x.key === e.key) as any;
    if (topLevelItem?.href) {
      console.log('click top level item', topLevelItem.href);
      setSelectedKey([topLevelItem.key]);
      history.push(topLevelItem.href);
      return;
    }

    for (const item of menuItems) {
      if (item && 'children' in item && item.children) {
        const childItem =
          item.children && (item.children.find((child: any) => child.key === e.key) as any);
        if (childItem?.href) {
          console.log('click child item', childItem.href);
          history.push(childItem.href);
          return;
        }
      }
    }
  };

  return (
    <nav className={Utils.mergeClasses(...navbarClasses)}>
      <>
        {showBanner && (
          <div className={styles.navbarBanner}>
            <div className={styles.navbarBannerContent}>
              {navbarTopAdvert && (
                <Link
                  href={navbarTopAdvert.url ?? '#'}
                  target="_blank"
                  className="text-white hover:text-white !hover:no-underline">
                  <Marquee>
                    <p className="text-white hover:text-white !hover:no-underline">
                      {navbarTopAdvert.text}
                    </p>
                  </Marquee>
                </Link>
              )}
            </div>
          </div>
        )}
        <div className="w-full h-15 bg-gray hidden lg:flex flex-row justify-center">
          <div className="w-full max-w-[1440px] flex flex-row justify-between px-5 lg:px-16 h-14">
            <div className="w-full flex flex-row bg-gray max-w-3xl pt-1">
              <Menu
                className="bg-gray text-sm w-full max-w-3xl"
                onClick={onClickItem}
                selectedKeys={selectedKey}
                mode="horizontal"
                items={menuItems}
              />
            </div>
            <div className="flex flex-row max-w-2xl gap-6 items-center">
              {!user && (
                <Link href={'/login'} className="gtm-track">
                  <Button type={'text'} size={'small'} id={'nav-btn-sign-in'}>
                    Login
                  </Button>
                </Link>
              )}
              {!user && (
                <Link href={'/sign-up'} className="gtm-track">
                  <Button size={'small'} type={'text'} id={'nav-btn-sign-up'}>
                    Register
                  </Button>
                </Link>
              )}

              <Link
                // href={postJobText === 'Recruiter Dashboard' ? '/recruiter' : '/guest-recruiter'}
                href={'/guest-recruiter'}
                className="gtm-track">
                <Button
                  size={'small'}
                  className={CommonStyles.borderedPrimaryButton}
                  icon={<PlusOutlined />}
                  id={'nav-btn-start-recruiting'}
                  // icon={postJobText === 'Recruiter Dashboard' ? undefined : <PlusOutlined/>}
                >
                  {postJobText}
                </Button>
              </Link>
              <Link href={'tel:+94727360360'} className="text-black flex items-center">
                {/*<ContentBlock className="!items-center w-40 ml-2" left={<FontAwesomeIcon icon="fa-solid fa-phone-volume" />}>*/}
                <ContentBlock
                  className="!items-center w-40 ml-2"
                  left={<FontAwesomeIcon icon={faPhoneVolume} />}>
                  +94 727 360 360
                </ContentBlock>
              </Link>
              {user && (
                <NavbarUserInfo
                  hideRecruiterButton={props.hideRecruiterButton}
                  onClickQuick={() => {
                    quick?.current?.show();
                  }}
                  onClickForeignJobs={() => {
                    history.push(foreignJobs);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.navbarContent}>
          <Link href={'/'} style={{ marginRight: 8 }} id={'nav-link-home'} className={'py-0.5'}>
            <Image
              className={styles.logo}
              src={Logo}
              alt={'Careers360 Logo'}
              width={185}
              height={43}
            />
          </Link>
          <div className="hidden md:flex w-full max-w-[482px] items-center mt-2.5 ml-2.5">
            <SearchAutocomplete
              prefix={
                <Image src={SearchIcon} width={20} height={20} alt="hot jobs" className="mr-2" />
              }
              className={styles.searchInputBarSearch2}
              value={value}
              showButton={false}
              triggerOnEnter={true}
              placeholder={'Job tittle, Keyword...'}
              getPopupContainer={(props1) => props1.parentNode}
              onChange={(val) => onSearch(val)}
              onClear={() => {
                setValue('');
                context.search({ search: undefined });
              }}
            />
          </div>

          <div className="flex flex-row w-full max-w-[594px] bg-gray ml-5 rounded-xl">
            {navbarAdvert && (
              <Link
                href={navbarAdvert.url ?? ''}
                target="_blank"
                rel="noreferrer"
                className="w-full">
                <Image
                  className="rounded-xl w-full h-auto"
                  unoptimized
                  src={navbarAdvert.image ?? ''}
                  alt={navbarAdvert.text ?? 'advertisement'}
                  width={0}
                  height={0}
                  sizes="100vw"
                  style={{ width: '100%', height: 'auto', maxHeight: '55px' }}
                />
              </Link>
            )}
          </div>

          {/*<div className={styles.navbarButtons}>*/}
          {/*{user?.quick && bp.lg && (*/}
          {/*  <>*/}
          {/*    <a>*/}
          {/*      <Button*/}
          {/*        onClick={() => quick.current?.show()}*/}
          {/*        size={'small'}*/}
          {/*        className={CommonStyles.borderedPrimaryButton}>*/}
          {/*        Quick Profile Build*/}
          {/*      </Button>*/}
          {/*    </a>*/}
          {/*  </>*/}
          {/*)}*/}

          {/*</div>*/}
        </div>
        {props.showSearch && (
          // <div className={styles.navbarContent}>
          <div>
            {/*{bp.md && (*/}
            {/*  <Select*/}
            {/*    value={searchType}*/}
            {/*    onChange={(value) => setSearchType(value)}*/}
            {/*    className={styles.searchInputBarSelect}*/}
            {/*    options={[*/}
            {/*      { label: 'Jobs', value: 'jobs' },*/}
            {/*      // { label: 'Courses', value: 'courses' },*/}
            {/*    ]}*/}
            {/*    getPopupContainer={(props1) => props1.parentNode}*/}
            {/*  />*/}
            {/*)}*/}
            {/*<SearchAutocomplete*/}
            {/*  className={styles.searchInputBarSearch}*/}
            {/*  showButton={true}*/}
            {/*  triggerOnEnter={true}*/}
            {/*  getPopupContainer={(props1) => props1.parentNode}*/}
            {/*  onChange={(val) => onSearch(val)}*/}
            {/*/>*/}
          </div>
        )}
        <div className={styles.navbarContentMobile}>
          <div className={styles.navbarSubContentMobile}>
            <div className="flex flex-row w-full justify-between relative">
              <Link href={'/'} style={{ marginRight: 8 }}>
                <Image
                  className={props.showLogin ? styles.logoX : styles.logo}
                  src={Logo}
                  alt={'Careers360 Logo'}
                />
              </Link>
              <div className="flex w-full gap-3 justify-end">
                <Link href={'/guest-recruiter'} className="gtm-track">
                  <Button
                    size={'small'}
                    className={CommonStyles.borderedPrimaryButton}
                    icon={<PlusOutlined />}
                    id={'nav-btn-start-recruiting'}
                    // icon={postJobText === 'Recruiter Dashboard' ? undefined : <PlusOutlined/>}
                  >
                    {postJobText}
                  </Button>
                </Link>
                {user && (
                  <NavbarUserInfo
                    hideRecruiterButton={props.hideRecruiterButton}
                    onClickQuick={() => {
                      quick?.current?.show();
                    }}
                    onClickForeignJobs={() => {
                      history.push(foreignJobs);
                    }}
                  />
                )}
                <MenuOutlined className="text-xl" onClick={() => setIsOpen(!isOpen)} />
              </div>
            </div>
            <div className={styles.bellContainer}>
              {/*{!user && (*/}
              {/*  <div className={styles.signinShowIconContainer}>*/}
              {/*    <Button*/}
              {/*      className={props.showLogin ? styles.signinHideIcon : styles.signinShowIcon}*/}
              {/*      onClick={props.onShowLogin}>*/}
              {/*      <Image alt="Sign in" src={signInIcon} height={30} />*/}
              {/*    </Button>*/}
              {/*  </div>*/}
              {/*)}*/}
              {/*{bp.md && user && <NotificationButton />}*/}
              {user && (
                <div style={{ alignItems: 'center' }} className={styles.navbarRow}>
                  {/*<div>{bp.xs && <NotificationButton />}</div>*/}
                  {/*<NavbarUserInfo*/}
                  {/*  hideRecruiterButton={props.hideRecruiterButton}*/}
                  {/*  onClickQuick={() => {*/}
                  {/*    quick?.current?.show();*/}
                  {/*  }}*/}
                  {/*  onClickForeignJobs={() => {*/}
                  {/*    history.push(foreignJobs);*/}
                  {/*  }}*/}
                  {/*/>*/}
                </div>
              )}
            </div>
          </div>

          {props.showSearch && (
            <div className={styles.navbarRow} style={{ marginTop: 8 }}>
              {bp.md && (
                <Select
                  value={searchType}
                  onChange={(value) => setSearchType(value)}
                  className={styles.searchInputBarSelect}
                  options={[
                    { label: 'Jobs', value: 'jobs' },
                    // { label: 'Courses', value: 'courses' },
                  ]}
                  getPopupContainer={(props1) => props1.parentNode}
                />
              )}
              <SearchAutocomplete
                className={styles.searchInputBarSearch}
                showButton={true}
                triggerOnEnter={true}
                getPopupContainer={(props1) => props1.parentNode}
                onChange={(val) => onSearch(val)}
              />
            </div>
          )}
        </div>
        <QuickProfileBuildModal ref={quick} />

        {isOpen && (
          <div className="fixed inset-0 z-40 top-[80px] left-0 right-0 bottom-0">
            {/* Dark overlay */}
            <div
              className="absolute inset-0 bg-black bg-opacity-40"
              onClick={() => setIsOpen(false)}
            />

            {/* Dropdown box (below navbar) */}
            <div
              ref={dropdownRef}
              className="absolute top-0 left-0 w-full bg-white z-50 shadow-md p-4 space-y-4 rounded-b-xl">
              <Link href="#" className="block text-[#5E6670] hover:text-red-600">
                Home
              </Link>
              <Divider className="my-1" />
              <Link href="#" className="block text-[#5E6670] hover:text-red-600">
                Foreign jobs
              </Link>
              <Divider className="my-1" />
              <Link href="#" className="block text-[#5E6670] hover:text-red-600">
                Customer Service
              </Link>
              <Divider className="my-1" />
              {!user && (
                <div className="flex gap-2">
                  <Button
                    className="text-white !px-3 py-1.5 !rounded-lg"
                    type="primary"
                    size="small">
                    Register Now
                  </Button>
                  <Button
                    className="border border-red-500 text-red-500 !px-3 py-1.5 !rounded-lg"
                    size="small">
                    Login
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </>
      {props.children}
    </nav>
  );
};
